if ($(".js-jj-landing-testimonial-slider").length > 0) {
    $(".js-jj-landing-testimonial-slider").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: true,
        appendArrows: $('.jj-landing-testimonial__slider-arrows'),
        prevArrow: '<div class="slick-prev slick-arrow"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33333 1.66675L1 10.0001L9.33333 18.3334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        nextArrow: '<div class="slick-next slick-arrow"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.66666 1.66675L9.99999 10.0001L1.66666 18.3334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        dots: true,
        appendDots: $('.jj-landing-testimonial__slider-dots'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '40px',
                }
            }
        ]
    });
}
function toggleWygSlider() {
    const $slider = $('.sb-what-you-get-inner-wrapper');

    if ($slider.length > 0) {
        if ($(window).width() < 1024) {
            if (!$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 10000,
                    arrows: true,
                    appendArrows: $('.wyg__slider-arrows'),
                    prevArrow: '<div class="slick-prev slick-arrow"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33333 1.66675L1 10.0001L9.33333 18.3334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
                    nextArrow: '<div class="slick-next slick-arrow"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.66666 1.66675L9.99999 10.0001L1.66666 18.3334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
                    dots: true,
                    appendDots: $('.wyg__slider-dots')
                });
            }
        } else {
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }
        }
    }
}
toggleWygSlider();
$(window).on('resize', function () {
    toggleWygSlider();
});


$(document).ready(function() {
    if ($('.tryout_page_custom #js-landing-faq-accordion').length > 0) {
        var faqAccordion = new Accordion({
            element: "#js-landing-faq-accordion",
            activeTab: 1
        });
    }
});
$(document).on('click', '.nutrition_ingredient_page', function (e) {  
        fetch("/pages/plenny-shake-v3-ingredients.json").then(r => r.json()).then(res => {
        $('.nutrition-information-popup-content .content-loader').html(res.page.body_html)
        // new Modal({el: document.getElementById('js-ingredient-nutrition-modal')}).show();
    })
    fetch("/pages/plenny-shake-v3-nutrition.json").then(r => r.json()).then(res => {
        $('.nutrition-information-popup-content .content-loader').append(res.page.body_html)
        new Modal({el: document.getElementById('js-ingredient-nutrition-modal')}).show();
    })

    async function loadContent_onload() {
    try {
        // First fetch call
        const ingredientResponse_onload = await fetch(`/pages/plenny-shake-v3-ingredients.json`);
        const ingredientData_onload = await ingredientResponse_onload.json();
        $('.nutrition-information-popup-content .content-loader').html(ingredientData_onload.page.body_html);
        $('.nutrition-information-popup-content').show();
        console.log('First element loaded---');
    } catch (error) {
        console.error('Error loading first element:', error);
    } finally {
        // Second fetch call (runs regardless of the first fetch success or failure)
        try {
            const nutritionResponse_onload = await fetch(`/pages/plenny-shake-v3-nutrition.json`);
            const nutritionData_onload = await nutritionResponse_onload.json();
            $('.nutrition-information-popup-content .content-loader').append(nutritionData_onload.page.body_html);
            // $('.nutrition-information-popup-content').show();
            console.log('Second element loaded----');
        } catch (error) {
            console.error('Error loading second element:', error);
        }
    }
}
})
$(document).on('click', '.ni-product-loader', function () {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    let nutrition_url = $(this).attr('nutrition-page-url');
    let ingredient_url = $(this).attr('ingredient-page-url')
    async function loadContent() {
        try {
            // First fetch call
            const ingredientResponse = await fetch(`/pages/${ingredient_url}.json`);
            const ingredientData = await ingredientResponse.json();
            $('.nutrition-information-popup-content .content-loader').html(ingredientData.page.body_html);
            $('.nutrition-information-popup-content').show();
            console.log('First element loaded---');
        } catch (error) {
            console.error('Error loading first element:', error);
        } finally {
            // Second fetch call (runs regardless of the first fetch success or failure)
            try {
                const nutritionResponse = await fetch(`/pages/${nutrition_url}.json`);
                const nutritionData = await nutritionResponse.json();
                $('.nutrition-information-popup-content .content-loader').append(nutritionData.page.body_html);
                // $('.nutrition-information-popup-content').show();
                console.log('Second element loaded----');
            } catch (error) {
                console.error('Error loading second element:', error);
            }
        }
    }

    // Call the function
    loadContent();

})

$(document).on('click', '[data-toggle="tab"]', function (e) {
    e.preventDefault();
    function handleize(str) {
        return str
            .toLowerCase().replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-').replace(/-+/g, '-');
    }
    var activeTab = handleize($(this).text());
    $('.information-modal').each(function (e) {
        $(this).find(".nav.nav-pills li").each(function (e) {
            var dd = $(this).text();
            let handleized = handleize(dd);
            if (handleized == activeTab) {
                var activeTab_href = $(this).find('a').attr('href');
                $(this).siblings('li').removeClass('active');
                $(this).addClass('active');
                $(activeTab_href).siblings('.tab-pane').hide().removeClass('active');
                $(activeTab_href).fadeIn().addClass('active');
            }
        })
    })
})

  document.addEventListener("DOMContentLoaded", function () {

  var locales = Shopify.locale || 'en'; // Default to 'en' if undefined

  // var content = {
  //   en: `
  //     <p dir="ltr">Curious about <b>balanced nutrition</b> but can't decide where to start? Our <b>Try-out Bundle</b> is perfect for first-timers: No guesswork, just simple, science-backed meals in form of our bestsellers.</p>
  //     <p dir="ltr">In this box you’ll get 26 shakes & bars:</p>
  //     <ul>
  //       <li dir="ltr">High protein</li>
  //       <li dir="ltr">26 vitamins & minerals</li>
  //       <li dir="ltr">Low sugar + smart carbs/fats/fiber</li>
  //       <li dir="ltr">FREE starter kit: shaker, scoop & starter guide</li>
  //     </ul>
  //   `,
  //   nl: `
  //     <p dir="ltr">Benieuwd naar <b>gebalanceerde maaltijden</b> maar weet je niet waar je moet beginnen? Onze <b>Try-out bundel</b> is perfect om mee te starten: geen giswerk, gewoon eenvoudige, wetenschappelijk onderbouwde maaltijden in de vorm van onze bestsellers.</p>
  //     <p dir="ltr">In deze box ontvang je 26 shakes & repen:</p>
  //     <ul>
  //       <li dir="ltr">Hoog in proteine</li>
  //       <li dir="ltr"> 26 vitamines & mineralen</li>
  //       <li dir="ltr">Laag in suiker + slimme koolhydraten/vetten/vezels</li>
  //       <li dir="ltr">GRATIS starterkit: shaker, scoop & starter guide</li>
  //     </ul>
  //   `,
  //   de: `
  //     <p dir="ltr">Neugierig auf <b>ausgewogene Ernährung</b>, aber keine Ahnung, wo du anfangen sollst? Unser <b>ry-out Bundle</b> ist perfekt für Einsteiger: kein Rätselraten, nur einfache, wissenschaftlich fundierte Ernährung mit unseren Bestsellern.</p>
  //     <p dir="ltr">In dieser Box erhältst du 26 Shakes & Riegel:</p>
  //     <ul>
  //       <li dir="ltr">Viel Protein</li>
  //       <li dir="ltr">26 Vitamine & Mineralstoffe</li>
  //       <li dir="ltr">Wenig Zucker + smarte Kohlenhydrate, Fette & Ballaststoffe</li>
  //       <li dir="ltr">GRATIS Starter-Kit: Shaker, Scoop & Starterheft</li>
  //     </ul>
  //   `
  // };

  // var container = document.querySelector('.product-detail__content');
  // if (container && content[locales]) {
  //   // container.innerHTML = content[locales];
  // }
  });
// const imageBases = {
//   '/products/try-out-bundle': {
//     en: [
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/Frame_266522787_3.png?v=1752155164',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-3_6a12a0f2-a01b-4f32-aaad-de6362ddf751.jpg?v=1750770469',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-3_5f7a1e58-3776-435d-b121-0ad2fb235c0e.png?v=1752151718',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-4-v1_7ffa112c-4da7-4c4e-830f-20318c256764.jpg?v=1750770470',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-5_9410e462-d1cc-43d2-907a-d1bef14fbf83.jpg?v=1750770469',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-7_366f8ed2-4e9d-4a75-90ff-e0dd7928a0af.jpg?v=1750770470',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-8_d09674fa-13bb-4f6b-8a6e-86617447c49d.png?v=1752151719',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-9_e68693b0-1483-47f1-b877-7efa9ee855c1.jpg?v=1752151718',
//     ],
//     de: [
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/Frame_266522787_4_91d7b780-350c-4c58-a66b-844d686ec976.png?v=1752641762',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-3_2_1599836d-4789-45cf-8de1-d3551eab67c2.jpg?v=1750827738',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-3_3_972a2c27-aa89-41b2-971f-28490e40cd04.jpg?v=1750827737',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-4-v1_1.jpg?v=1750827737',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-5_1.jpg?v=1750827736',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-7_1.jpg?v=1750827737',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-8_1.jpg?v=1750827736',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-9_2_604b5a5f-a201-4528-b1de-f1620683273c.jpg?v=1752641761',
//     ],
//     nl: [
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/Frame_266522787_5_59892369-f551-4a48-99aa-5c1c3af37637.png?v=1752641814',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-3_970ae52f-ef9f-47bc-a6a1-67cbd63e932f.png?v=1751544955',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-3_1_7fa98546-10fc-47bf-86e3-a6478418dba6.png?v=1751545180',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-4-v1_38f1613c-1c3d-4c92-ae97-f629eb0b8b05.png?v=1751544956',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-5_4041d646-ea42-48b6-9acf-1b604ef2cf1e.png?v=1751544955',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-7_4138654d-017a-4864-8d67-dfa1171f30f3.png?v=1751544956',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-8_d6045c94-494c-46ec-98d1-32a68d663a7d.png?v=1751544955',
//       'https://cdn.shopify.com/s/files/1/0004/9630/4187/files/image-9_3.jpg?v=1752641814'
//     ]
//   },
// };
// Simulate Shopify.locale or use URL pathname to detect locale
  function detectLocale() {
    let detectlocale = 'en';
    if (window.location.pathname.startsWith('/nl')) detectlocale = 'nl';
    else if (window.location.pathname.startsWith('/de')) detectlocale = 'de';
    return detectlocale;
  }
// // Helper to create a product object from one image URL
// function createProductFromUrl(url) {
//   // For demo, we'll reuse url for all src/nav versions; 
//   // You can adjust to generate srcset and sizes as needed
//   return {
//     mainSrc: url,
    
//     navSrc: url,
   
//   };
// }

// Build products array dynamically
// const productPath = '/products/try-out-bundle';
//     let localevalue = detectLocale();
//     // normalize path, e.g. remove locale prefix if any
//     let path = window.location.pathname;
//     path = path.replace(/^\/(nl|de|en)(\/products\/)/, '/products/');
//     const products = (imageBases[productPath]?.[localevalue] || []).map(createProductFromUrl);
//     // Your existing renderProductSlider function unchanged:
//     function renderProductSlider() {
//       const container = document.querySelector('.product-slider');
//       if (!container || products.length == 0) {
//         console.error('No container with class ".product-slider" found.');
//         return;
//       }

//   // Build main slides HTML
//   const mainSlides = products.map((product, i) => `
//     <div class="product-slider__item ${i === 0 ? 'is-selected' : ''}">
//       <div class="product-slider__media">
//         <img
         
//           src="${product.mainSrc}"
//           alt=""
//           class="img"
//           loading="lazy"
//         />
//       </div>
//     </div>
//   `).join('');

//   // Build nav slides HTML
//   const navSlides = products.map((product, i) => `
//     <div class="product-slider__item ${i === 0 ? 'is-nav-selected is-selected' : ''}">
//       <div class="product-slider__media">
//         <img
        
//           src="${product.navSrc}"
//           alt=""
//           class="img"
//           loading="lazy"
//           style="object-fit: contain;"
//         />
//       </div>
//     </div>
//   `).join('');

//   // Replace container content
//   container.innerHTML = `
//     <div class="product-slider__main js-product-slider-main flickity" data-flickity='{
//       "sync": ".js-product-slider-nav",
//       "cellAlign": "left",
//       "contain": true,
//       "prevNextButtons": false,
//       "fade": true,
//       "pageDots": true,
//       "wrapAround": true,
//       "lazyLoad": true
//     }'>
//       ${mainSlides}
//     </div>
//     <div class="product-slider__nav js-product-slider-nav flickity" data-flickity='{
//       "asNavFor": ".js-product-slider-main",
//       "cellAlign": "left",
//       "contain": true,
//       "pageDots": false,
//       "groupCells": 5,
//       "arrowShape": "M23.5,50c0,1.9,0.7,3.5,2,4.9L60.7,90c1.3,1.3,2.9,2,4.9,2c1.9,0,3.5-0.7,4.9-2l4.1-4c1.3-1.4,2-3,2-4.9c0-1.9-0.7-3.5-2-4.9L48.3,50l26.2-26.1c1.3-1.4,2-3,2-4.9c0-1.9-0.7-3.5-2-4.9l-4.1-4c-1.3-1.4-2.9-2-4.9-2c-1.9,0-3.6,0.7-4.9,2L25.5,45.1C24.2,46.5,23.5,48.1,23.5,50z",
//       "lazyLoad": true
//     }'>
//       ${navSlides}
//     </div>
//   `;

//   // Initialize Flickity sliders
//   const mainSliderElem = container.querySelector('.js-product-slider-main');
//   const navSliderElem = container.querySelector('.js-product-slider-nav');

//   new Flickity(mainSliderElem, {
//     sync: navSliderElem,
//     cellAlign: 'left',
//     contain: true,
//     prevNextButtons: false,
//     fade: true,
//     pageDots: true,
//     wrapAround: true,
//     lazyLoad: true,
//   });

//   new Flickity(navSliderElem, {
//     asNavFor: mainSliderElem,
//     cellAlign: 'left',
//     contain: true,
//     pageDots: false,
//     groupCells: 5,
//     arrowShape: 'M23.5,50c0,1.9,0.7,3.5,2,4.9L60.7,90c1.3,1.3,2.9,2,4.9,2c1.9,0,3.5-0.7,4.9-2l4.1-4c1.3-1.4,2-3,2-4.9c0-1.9-0.7-3.5-2-4.9L48.3,50l26.2-26.1c1.3-1.4,2-3,2-4.9c0-1.9-0.7-3.5-2-4.9l-4.1-4c-1.3-1.4-2.9-2-4.9-2c-1.9,0-3.6,0.7-4.9,2L25.5,45.1C24.2,46.5,23.5,48.1,23.5,50z',
//     lazyLoad: true,
//   });
// }

// Run when DOM is ready
// if(window.template =="new-try-out-bundle"){
//   if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', renderProductSlider);
// } else {
//   renderProductSlider();
// }  
// }




